export const AVATAR_MAX_BYTES = 5 * 1024 * 1024;
export const ALLOWED_AVATAR_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);

export type AvatarPickerFile = {
  uri: string;
  type?: string;
  name?: string;
  file?: Blob;
};

export function normalizeImageMime(type?: string | null) {
  const value = (type || '').toLowerCase().split(';')[0].trim();
  if (value === 'image/jpg') {
    return 'image/jpeg';
  }
  return value;
}

export function avatarUploadFileName(name: string | undefined, mime: string) {
  const ext = mime === 'image/png' ? 'png' : mime === 'image/webp' ? 'webp' : 'jpg';
  const base = (name || 'avatar').replace(/\.[^.]+$/, '') || 'avatar';
  return `${base}.${ext}`;
}

export function readApiErrorMessage(body: unknown, fallback: string) {
  if (!body || typeof body !== 'object' || !('message' in body)) {
    return fallback;
  }
  const message = (body as { message: unknown }).message;
  if (typeof message === 'string' && message.trim()) {
    return message;
  }
  if (Array.isArray(message) && typeof message[0] === 'string' && message[0].trim()) {
    return message[0];
  }
  return fallback;
}
